import { CallRecordingPlaybackEvent } from '@/components/CallRecordingPlayer';
import { PostHog } from 'posthog-js/react';
import { trackCallRecordingPlayed, trackCallRecordingPaused } from '@/services/analytics';
import { TimelineVoiceCommunication } from '../types';

interface CallRecordingTrackingParams {
  item: TimelineVoiceCommunication;
  posthog: PostHog;
  organizationId?: string;
  patientId?: string;
}

export function callRecordingPlayHandler({
  item,
  posthog,
  organizationId,
  patientId,
}: CallRecordingTrackingParams): (event: CallRecordingPlaybackEvent) => void {
  return ({ playbackRate, currentTimeSeconds }) => {
    const callId = item.reference.reference ?? item.reference.id!;

    if (organizationId) {
      trackCallRecordingPlayed(posthog, {
        call_id: callId,
        playback_speed: playbackRate,
        playhead_position_seconds: currentTimeSeconds,
        organization_id: organizationId,
      });
    } else if (patientId) {
      trackCallRecordingPlayed(posthog, {
        call_id: callId,
        playback_speed: playbackRate,
        playhead_position_seconds: currentTimeSeconds,
        patient_id: patientId,
      });
    }
  };
}

export function callRecordingPauseHandler({
  item,
  posthog,
  organizationId,
  patientId,
}: CallRecordingTrackingParams): (event: CallRecordingPlaybackEvent) => void {
  return ({ playbackRate, currentTimeSeconds }) => {
    const callId = item.reference.reference ?? item.reference.id!;

    if (organizationId) {
      trackCallRecordingPaused(posthog, {
        call_id: callId,
        playback_speed: playbackRate,
        playhead_position_seconds: currentTimeSeconds,
        organization_id: organizationId,
      });
    } else if (patientId) {
      trackCallRecordingPaused(posthog, {
        call_id: callId,
        playback_speed: playbackRate,
        playhead_position_seconds: currentTimeSeconds,
        patient_id: patientId,
      });
    }
  };
}
